<template>
  <section class="company-page">
    <company-header :h1Content="h1Content" />
    <company-info :introContent="introContent" />
    <company-buttons :products="products" />
    <app-question-panel
      class="mt-16"
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
  </section>
</template>

<script>
import companyHeader from '@/component/company/CompanyHeader'
import companyInfo from '@/component/company/CompanyInfo'
import appQuestionPanel from '@/component/expansional-question-panel/AppQuestionPanel'
import companyButtons from '@/component/company/CompanyButtons'

export default {
  metaInfo: {
    title: 'Groupama Sigorta Fiyatları İçin Teklif Alın, Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          "Groupama Sigorta'dan fiyat teklifi alarak karşılaştırma yapın, en iyi sigorta planlarına online ulaşın. Groupama Sigorta Güvencesi ile poliçenizi satın alın."
      }
    ]
  },
  name: 'GroupamaSigorta',
  components: {
    companyHeader,
    companyInfo,
    appQuestionPanel,
    companyButtons
  },
  data () {
    return {
      h1Content: 'Groupama Sigorta Fiyatları',
      faqTitle: 'Groupama Sigorta Hakkında Merak Edilen Sorular',
      faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
      products: {
        title: 'Groupama Sigorta Ürünleri',
        buttons: [
          {
            id: 1,
            title: 'TRAFİK SİGORTASI',
            class: 'company--btn--icons fas fa-car fa-2x mr-2',
            path: 'GroupamaSigortaCompulsoryTraffic'
          },
          {
            id: 2,
            title: 'KASKO SİGORTASI',
            class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
            path: 'GroupamaSigortaMotorInsurance'
          },
          {
            id: 3,
            title: 'DASK SİGORTA',
            class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
            path: 'GroupamaSigortaDaskInsurance'
          },
          {
            id: 4,
            title: 'KONUT SİGORTASI',
            class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
            path: 'GroupamaSigortaHomeInsurance'
          },
          {
            id: 5,
            title: 'İŞYERİ SİGORTASI',
            class: 'company--btn--icons fas fa-building fa-2x mr-2',
            path: 'GroupamaSigortaCompanyInsurance'
          },
          {
            id: 6,
            title: 'FERDİ KAZA SİGORTASI',
            class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
            path: 'GroupamaSigortaPersonalAccident'
          },
          {
            id: 7,
            title: 'NAKLİYAT SİGORTASI',
            class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
            path: 'GroupamaSigortaTransportation'
          },
          {
            id: 8,
            title: 'ÖZEL SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-heartbeat fa-2x mr-2',
            path: 'GroupamaSigortHealthInsurance'
          },

          {
            id: 9,
            title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
            path: 'GroupamaSigortaComplementaryHealth'
          },
          {
            id: 10,
            title: 'SEYAHAT SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
            path: 'GroupamaSigortaTravelInsurance'
          },
          {
            id: 11,
            title: 'YABANCI SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-user-md fa-2x mr-2',
            path: 'GroupamaSigortaForeignInsurance'
          }
        ]
      },
      introContent: {
        title: 'Groupama Sigorta Hakkında',
        content: [
          {
            paragraph:
              'Groupama Sigorta, 1924 yılında Güven Sigorta olarak kuruldu.'
          },
          {
            paragraph:
              '1959 yılında T.C. Ziraat Bankası desteğiyle Başak Sigorta unvanı ile sektöre katılım sağladı. 2008 yılında özelleştirmeden sonra Güven Sigorta ile birleşimlerini tamamlayarak,  2009 yılında Groupama Sigorta unvanını almıştır.'
          },
          {
            paragraph:
              'Şirketin hedefi, Türkiye’nin en fazla tercih edilen öncü sigorta şirketi olmaktır. Şirket hedefine, Kalite Yönetim Sistemi kuralları çerçevesinde ulaşmayı planlamaktadır.'
          },
          {
            paragraph:
              'Müşterilerin avantajlarını ön planda tutarak, standart sigortacılık anlayışının dışında, hizmetlerinin ötesinde güven sağlamayı ilke edinen Groupama Sigorta, geniş kapsamlı teminatları ve uygun fiyatlarıyla yanınızdadır.'
          }
        ]
      },
      questions: [
        {
          title: 'Groupama Sigorta Ürün Çeşitleri Nelerdir?',
          content: [
            {
              paragraph:
                'Groupama Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz bünyesinde size özel teklif verebileceğimiz bazı sigorta ürünlerimiz;',
              subList: [
                'Trafik Sigortası',
                'Araç Kasko Sigortası',
                'DASK (Zorunlu Deprem Sigortası)',
                'Konut Sigortası',
                'İşyeri Sigortası',
                'Ferdi Kaza Sigortası',
                'Nakliyat Sigortası',
                'Seyahat Sağlık Sigortası.'
              ]
            },
            {
              paragraph:
                'Tüm bu branşlarda ihtiyaç duyduğunuz poliçelere sahip olmak için sigorta uzmanlarımızla görüşebilir ya da online teklif ekranlarımızı kullanabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Groupama Sigorta ile özel anlaşmalarımız gereği, hiçbir yerde bulamayacağınız ekstra teminat ve çok uygun rakamlarla poliçenizi ALOKASKO uzmanlaından yaptırabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Groupama Sigorta ürünlerinden faydalanmak isteyen müşterilerimiz <strong><em><u>alokasko.com</u></em></strong> sayfamızdan en kapsamlı teminatlara ve en uygun primlere ulaşabilir.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Zorunlu Trafik Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Groupama Sigorta Zorunlu Trafik Sigortası ile trafikte yapmış olduğunuz kazalarda kusurlu olmanız durumunda üçüncü şahısların zararlarını teminat dâhilinde Groupama Sigorta kapsamında güvence altına alabilirsiniz. ',
              subList: null
            },
            {
              paragraph:
                'Teminatlar her yıl Devlet Hazine Müsteşarlığı tarafından belirlenmektedir. ',
              subList: null
            },
            {
              paragraph:
                'Groupama trafik sigortası poliçenize “İMM (İhtiyari Mali Sorumluluk Sigortası)” ekleyerek poliçenizin yeterli olmadığı durumlarda oluşabilecek masrafları da güvence altına alabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Sunulan bu hizmetlerden faydalanmak istediğiniz anda Alokasko.com sigorta danışmanlarını aramanız ya da online teklif almanız yeterli olacaktır. ',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Araç Kasko Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Groupama Sigorta Kasko Sigortası kendi aracınızda oluşabilecek hasarları ve kayıpları güvence altına almaktadır. Zorunlu trafik sigortası kapsamına girmeyen kendi aracınızın hasarlarını kasko sigortası ile güvence altına alabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                '<strong>Groupama Sigorta Kasko Sigortası Paketleri:</strong> ',
              subList: [
                'SÜPER ÖZEL OTO',
                'ELİT KASKO',
                'KLASİK KASKO',
                'MARKA KASKO',
                'MOTO KASK’O'
              ]
            },
            {
              paragraph:
                '** En uygun paket içeriğini seçebilmek için karşılaştırma yapmalısınız. Groupama Sigorta Kasko Sigortası Planları araç tipi ve kullanım tarzına göre belirlenmiştir.',
              subList: null
            },
            {
              paragraph:
                '<strong>Genel Kasko Teminatlarından Bazıları:</strong>',
              subList: [
                'Çarpma, çarpışma, devrilme, yanma',
                'Çalınma',
                'Yetkili olmayan kişilerce çekilme ',
                'GLHH, terör ve üçüncü kişilerin kötü niyetli hareketleri ',
                'Deprem, fırtına, dolu, yıldırım, toprak kayması ve yanardağ püskürmesi',
                'Sel, su baskını',
                'Sigara ve benzeri zararlar',
                'Anahtar kaybı, kilit mekanizma değişikliği ',
                'Kemirgen hayvan zararları',
                'Yanlış akaryakıt dolumu ',
                'Özel eşya teminatı ',
                'İMM teminatı',
                'Ferdi kaza teminatı',
                'Mini onarım hizmeti'
              ]
            },
            {
              paragraph:
                'Tüm teminatlar Genişletilmiş Kasko teminatları kapsamındadır. Cebinizden ekstra bir ücret ödemeden poliçe kapsamında tüm zararlarınızı karşılatabilir, ağır hasar olması durumunda aracınızın piyasa bedelini geri alabilirsiniz. ',
              subList: null
            },
            {
              paragraph:
                'Trafikte ya da aracınız park halindeyken oluşabilecek öngörülmeyen riskleri kasko sigortası kapsamında koruma altına alarak, bütçenizden tasarruf edin.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Kanunen yaptırılması zorunlu olan deprem sigortanızı Groupama Sigorta’dan yaptırabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Zorunlu deprem sigortası poliçesi, deprem ve deprem sonucu oluşabilecek riskleri güvence altına almaktadır.',
              subList: null
            },
            {
              paragraph:
                'DASK primleri hesaplanırken öncelikle bulunduğunuz bölgenin risk durumu dikkate alınmaktadır. ',
              subList: null
            },
            {
              paragraph:
                'Hasarsız geçen her yılsonunda yenilenen poliçeden %5, %10 ,%20 indirim kazanılmaktadır. Üç yıl üst üste aralıksız yenilenmesi durumunda % 20’ye ulaşır ve en üst indirim basamağıdır. Hasar durumunda sigortalının alacağı sigorta bedeli, her yıl Hazine Müsteşarlığı tarafından belirlenen metrekare başına düşen inşa bedeli ile hesaplanır. ',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Konut Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Groupama Sigorta konut sigortası eşyalarınızı, sevdiklerinizi ve oturduğunuz binayı güvence altına almaktadır. Yaptırılması zorunlu olan deprem sigortası ile sık karıştırılsa da konut sigortası, deprem sigortası ile aynı hasarları karşılamaz. Bu yüzden deprem sigortanız var diye konut sigortası yaptırmamayı düşünmemelisiniz.',
              subList: null
            },
            {
              paragraph:
                '<strong>Groupama Sigorta Konut Sigortası Paketleri: </strong>',
              subList: ['  SÜPER KONUT ', 'KOLAY KONUT']
            },
            {
              paragraph:
                '<strong><em><u>Süper Konut Süper Konut Sigortası:</u></em></strong> Planda sunulan geniş kapsamlı teminatlar sayesinde evinizi, eşyalarınızı ve sevdiklerinizi güvence altına almaktadır.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Kolay Konut Kolay Konut Sigortası:</u></em></strong> Kapsamında sunulan çeşitli teminatlar ile hem evinize hem de evinizin sabit kıymetlerine karşı teminat sağlar.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta İşyeri Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Groupama İşyeri Sigortası kapsamında sunulan farklı paketler mevcuttur. Bu paketler içeriğine göre işverenlerin ihtiyaçlarına yetişiyor.',
              subList: [
                ' Kobi Sigortası',
                'Ticari / Sinai İşletme',
                'Endüstriyel Yangın'
              ]
            },
            {
              paragraph:
                'İşyeri Sigortası kapsamında sunulan teminatları değerlendirmek isteyen tüm adaylar sigorta danışmanlarımızdan destek alabilir.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Ferdi Kaza Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Groupama Ferdi Kaza Sigortası, meydana gelebilecek kazalara karşı güvence sağlamaktadır. Poliçe kapsamında yaşanacak bir kaza sonucunda sigortalının sakatlanma riskine veya vefat etme durumuna karşı hem sevdiklerini hem de sigortalıyı güvence altına almaktadır.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Ferdi kaza sigortası kapsamında sunulan hizmet avantajları:</u></em></strong> Ferdi Kaza Asistans Hizmetleri - Diş Sağlığı Paketi - Göz Sağlığı Paketi - Acil Şifalar Teminatıdır.',
              subList: null
            },
            {
              paragraph: 'Ürün Planları:',
              subList: ['Ferdi Kaza Plus ', 'Kaza Destek.']
            },
            {
              paragraph:
                'Ferdi kaza sigortası yaptırmak tamamen isteğe bağlıdır. Zorunlu bir sigorta çeşidi değildir. Bu kapsamda ilgili teklifleri inceleyerek, faydalarını göz önünde bulundurmalı ve en doğru teminatları satın alarak, gelecekteki riskleri kontrol altında tutmalısınız.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Nakliyat Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Emtea ve Kıymet Nakli Sigortası, büyük montanlı işleri ve riskleri güvence altına almaktadır.',
              subList: null
            },
            {
              paragraph:
                'Denizyolu, karayolu, havayolu ve demiryolu nakliyatını yapan kişilerin mallarına gelebilecek zararları nakliyat sigortası kapsamında güvence altına alınmaktadır. Poliçeniz kapsamında oluşabilecek hasar durumlarınız Groupama Sigorta ile güvence altında!',
              subList: null
            },
            {
              paragraph:
                '<strong>Teminat kapsamı 3 farklı şekildedir.</strong>',
              subList: [' Tam Ziya', 'Dar Teminat', 'Geniş Teminat.']
            }
          ]
        },
        {
          title: 'Groupama Sigorta Seyahat Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Hem yurtiçi hem de yurt dışı yapacağınız seyahatlerde güvenceniz Groupama Sigorta!',
              subList: null
            },
            {
              paragraph:
                '<strong>Yurt Dışı Seyahat Sağlık Sigortası Kapsamı:</strong>',
              subList: null
            },
            {
              paragraph:
                '<ol><li>1. Bölge: ABD, Kanada, Japonya hariç tüm Dünya </li> <li>2. Bölge: Tüm Dünya Teminat Dışı Bölgeler: Irak, Afganistan, Gazze Şeridi</li></ol>',
              subList: null
            },
            {
              paragraph:
                '<strong>Yurt Dışı Seyahat Sağlık Sigortası Paketleri:</strong>',
              subList: [
                'Klasik Yurt Dışı Seyahat Sağlık Sigortası ',
                'VIP Yurt Dışı Seyahat Sağlık Sigortası',
                'EKO Yurt Dışı Seyahat Sağlık Sigortası',
                'Smart Seyahat Sağlık Sigortası'
              ]
            },
            {
              paragraph:
                '<strong>Yurtiçi Seyahat Sağlık Sigortası Paketleri:</strong>',
              subList: [
                'Klasik Yurt İçi Seyahat Sağlık Sigortası',
                'VIP Yurt İçi Seyahat Sağlık Sigortası'
              ]
            },
            {
              paragraph:
                'Planları detaylı incelemek için teklif almanız gerekmektedir.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Poliçe Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Groupama Sigorta poliçe sorgulaması yapmak isteyen bireysel müşteriler, sigorta şirketinin resmi web site adresini ziyaret ederek “<strong><em><u>Online İşlemler</u></em></strong>” sayfana giriş yapmalıdır.',
              subList: null
            },
            {
              paragraph:
                'Giriş yapılan sayfa üzerinden hangi branşta işlem yapmak istiyorsanız o adımı takip etmeniz gerekmektedir.',
              subList: null
            },
            {
              paragraph:
                'Alokasko.com web sitesinden satın almış olduğunuz tüm poliçeler için sigorta danışmanınızı <strong><em><u>0216 371 67 77</u></em></strong> numaralı hattan arayabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Groupama güvencesinde satın alınan sigorta poliçesi kapsamında yaşanan hasarlarda hasar uzmanları size destek olmaktadır. Açılan hasar dosyanızı sorgulama istiyorsanız sigortacınızla iletişime geçebilir ya da sigorta şirketinin web sitesini ziyaret ederek sorgulama yapabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>alokasko.com</u></em></strong> web sitesinden satın almış olduğunuz tüm poliçeler kapsamında yaşanan hasarları hasar uzmanlarımız takip eder. Sigorta danışmanınızı <strong><em><u>0216 371 67 77</u></em></strong> numaralı hattan arayarak detaylı bilgi alabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Groupama Sigorta Poliçe Fiyatı Nasıl Alınır?',
          content: [
            {
              paragraph:
                'Groupama Sigorta Alokasko.com ‘un anlaşmalı sigorta şirketidir. En uygun tekliflere ulaşmak için web sitemizden fiyat al formunu doldurmanız yeterlidir. Bu kapsamda online teklif adımları sizi en doğru fiyata ulaştıracaktır. ',
              subList: null
            },
            {
              paragraph:
                'Teklif al formunu doldurmanız sonucunda size özel atacağımız sigorta danışmana merak ettiğiniz soruları ve indirimleri sorabilirsiniz.',
              subList: null
            }
          ]
        }
      ]
    }
  }
}
</script>
